import React, { FC, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loggedInUser } from '../store/MeAction';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { CoreLoggedInUser } from '../models/CoreLoggedInUser';
import { useTranslation } from 'react-i18next';
import LanguageSwitch from './LanguageSwitch';
import { RootState } from '../store/store';
import { Button } from 'reactstrap';
import UserInfo from './misc/UserInfo';

const isUserInfoElement = (element: HTMLElement) => {
    let isUserInfo = false;

    while (element) {
        if (element.id === 'user-info') {
            isUserInfo = true;
            break;
        }
        if (element.id === 'user-info2') {
            isUserInfo = true;
            break;
        }
        element = element.parentElement as HTMLElement;
    }

    return isUserInfo;
};

const Top: FC<{}> = () => {
    const { t } = useTranslation(['common']);
    const dispatch = useDispatch();
    const [showInfo, setShowInfo] = useState(false);
    const me = useSelector<RootState, CoreLoggedInUser | undefined>(state => state.me.me);

    useEffect(() => {
        loggedInUser()(dispatch);
        return () => {
            window.removeEventListener('scroll', hideOnScroll)
            document.removeEventListener('click', hideOnClick);
        }
    }, [dispatch])

    useEffect(() => {
        if (!me?.customer) {
            document.title = 'FlowSync';
            return;
        }
        document.title = `${me?.customer} - FlowSync`;
    }, [me?.customer])
    
    const hideOnScroll: (this: Window, event: Event) => void = useCallback((event) => {
        hideInfo();
    }, []);

    const hideOnClick: (this: Document, event: Event) => void = useCallback((event) => {
        if (isUserInfoElement(event.target as HTMLElement)) {
            return;
        }

        hideInfo();
    }, [])

    const hideInfo = useCallback(() => {
        setShowInfo(false);

        window.removeEventListener('scroll', hideOnScroll)
        document.removeEventListener('click', hideOnClick);
    }, []);

    const showUserInfo = useCallback(() => {
        if (showInfo) {
            hideInfo();
            return;
        }

        setShowInfo(true);
        window.addEventListener('scroll', hideOnScroll, {once: true})
        document.addEventListener('click', hideOnClick)
    }, [showInfo]);

    return <div className="top">
        {me !== undefined && <React.Fragment>
                <div>{me.customer}</div>
                    <div className="user" id="user-info">
                        <div className="flex">
                            <LanguageSwitch />
                            <div className="displayname">{me.displayName} </div>
                    <div ><Button className="btn-icon btn-icon-padding" title={t('userDisplay.btnTooltip', { ns: 'common' })} onClick={showUserInfo}> <FontAwesomeIcon icon="user" /></Button> </div>
                        </div>
                    <div>
                        {showInfo && <UserInfo user={me} />}
                </div>
            </div>
        </React.Fragment>}
    </div>;
}

export default Top;
